<template>
    <span>
        <a-button size="small" type="primary" icon="check" v-on:click.prevent="showModal">Sol. Vacaciones</a-button>
        <a-modal title="Solicitar Vacaciones"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar">
          <a-form-model layout="vertical" :model="iVacaciones" :rules="formRules"
                        @submit="confirmar"
                        @submit.native.prevent ref="formVacaciones">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Fecha inicio')" prop="pd_fechainicio" has-feedback>
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-model="iVacaciones.pd_fechainicio"
                                 @change="actualizaFechaRegreso"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Días Solicitados')" prop="pn_dias" has-feedback>
                  <a-input v-model="iVacaciones.pn_dias" @change="actualizaFechaRegreso">
                  </a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Fecha De Regreso')" prop="identificacion_financiera" has-feedback>
                  <a-input v-model="iVacaciones.pd_fechafin" disabled>
                    <a-tooltip slot="suffix" title="Calculado automáticamente">
                      <a-icon v-if="modalLoading" type="loading"/>
                      <a-icon v-else type="info-circle" style="color: rgba(0,0,0,.45)"/>
                    </a-tooltip>
                  </a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Días Compensados')" prop="pn_diasdinero" has-feedback>
                  <a-input-number style="width: 100%;" v-model="iVacaciones.pn_diasdinero"></a-input-number>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Periodo')" prop="pn_period" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       v-model="iVacaciones.pn_period"
                                       endpoint="hierarchy_lookup"
                                       :params="period_request"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Fecha pago')" prop="pd_fechapago" has-feedback>
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-model="iVacaciones.pd_fechapago"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Completo')" prop="pn_completo" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iVacaciones.pn_completo"
                                       :customSlots="['suffixIcon']"
                                       :params="estado_sn"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Comentarios')" prop="pv_observaciones" has-feedback>
                <a-textarea placeholder=""
                            autoSize
                            v-model="iVacaciones.pv_observaciones">
                </a-textarea>
                </a-form-model-item>
              </a-col>
              <a-alert type="error" :message="mensajeError" v-if="error"/>
            </a-row>
          </a-form-model>
        </a-modal>
    </span>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['p_id_emp'],
    data () {
      return {
        estado_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        colSpan: {
          xs: 24,
          md: 8
        },
        formRules: {},
        iVacaciones: {},
        modalVisible: false,
        modalLoading: true,
        error: false,
        diasParams: {
          h_lookup_type: 'DIAS_SOL_VAC',
          use_code: true
        },
        period_request: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    methods: {
      initFormRules () {
        this.formRules = {
          name: [{
            required: true,
            message: 'Valor requerido'
          }]
        }
      },
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar () {
        this.$refs.formVacaciones.validate(valid => {
          if (valid) {
            this.modalLoading = true
            this.iVacaciones.pv_idemp = this.p_id_emp
            this.httpClient.getInstance().post('dist_vac/generate_dist_vac', this.iVacaciones)
              .then((response) => {
                Mensajes.success('Correcto', response.data.pv_message)
                this.$emit('modalOk')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.modalLoading = false
                this.modalVisible = false
                this.iVacaciones = {}
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
      },
      async calcularFechaRegreso (record) {
        try {
          return await this.httpClient.getInstance().post('dist_vac/calcular_fecha_regreso', record)
        } catch (e) {
          console.log(e)
        }
      },
      actualizaFechaRegreso () {
        if (!JsUtils.isEmpty(this.iVacaciones.pd_fechainicio) && !JsUtils.isEmpty(this.iVacaciones.pn_dias)) {
          this.modalLoading = true
          let record = {
            htv_since: this.iVacaciones.pd_fechainicio,
            htv_time: this.iVacaciones.pn_dias,
            id_emp: this.p_id_emp
          }
          this.calcularFechaRegreso(record)
            .then((response) => {
              let ff = moment(response.data.return)
              this.iVacaciones.pd_fechafin = ff.format('YYYY-MM-DD')
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posible calcular la fecha de regreso.')
            })
            .then(() => {
              this.modalLoading = false
            })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/BotonSolicitarVacaciones.vue